module.exports = __webpack_public_path__ + "assets/svg/UI/map-pin-clock-in-cdd373.svg";